import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  const failedStrategies = ['La segmentación por intereses está saturada y Meta ya no confía en esos datos para optimizar.', 'Los Públicos Similares (Lookalikes) están contaminados con datos de baja calidad de navegantes curiosos.', 'Probar 50 variantes creativas sin una tesis de identidad clara solo confunde al algoritmo y agota tu paciencia.', 'El miedo a dejar la segmentación abierta (Broad) te mantiene atrapado en nichos pequeños y costosos que no escalan.'];
  return <section className="py-20 px-4 relative bg-[#0d1117]/50 border-y border-white/5" data-id="element-81">
      <div className="max-w-3xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-83">
          <div className="flex items-center gap-3 mb-6" data-id="element-84">
            <AlertTriangleIcon className="w-8 h-8 text-red-500" data-id="element-85" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-86">
              El cementerio de presupuestos
            </h2>
          </div>

          <div className="space-y-6 text-lg leading-[1.8] text-slate-300 mb-16" data-id="element-87">
            <p data-id="element-88">
              Desde la actualización de iOS14, Meta ya no recibe datos precisos
              de comportamiento. Lo que antes era una ciencia exacta, hoy es un
              cementerio de presupuestos desperdiciados.
            </p>
            <p data-id="element-89">
              Si sigues intentando segmentar por{' '}
              <span className="text-red-400 font-medium" data-id="element-90">"Interés: Yoga"</span>{' '}
              o{' '}
              <span className="text-red-400 font-medium" data-id="element-91">
                "Dueños de negocio"
              </span>
              , estás compitiendo en la subasta más cara y ruidosa del mundo,
              mostrándole tus anuncios a personas que Meta "cree" que les gusta
              algo, pero que no tienen intención de compra real.
            </p>
          </div>

          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-92">
            Por qué lo que intentaste no funcionó:
          </h3>

          <div className="space-y-4" data-id="element-93">
            {failedStrategies.map((strategy, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#161b22] p-6 rounded-xl border border-red-500/10" data-id="element-94">
                <div className="mt-1 bg-red-500/10 p-1 rounded-full shrink-0" data-id="element-95">
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-96" />
                </div>
                <p className="text-slate-300 leading-relaxed" data-id="element-97">{strategy}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}